/* eslint-disable */
import { EmptyMessage, IdentityMessage } from '../util/messages';
import { Injectable } from '@angular/core';
import { AddressResource } from '../address';
import { Observable } from 'rxjs';
import { BaseHttpService, ResourceHelper } from '../util/http-services';
import { HttpClient } from '@angular/common/http';
import { ResourceQueryResult } from '../util/services';
import { HistoryLog } from '../history-log/history-log.service';
/* eslint-enable */

@Injectable()
export class CompanyLocationResourceService extends BaseHttpService {

  query(request: CompanyLocationResource.QueryRequest): Observable<ResourceQueryResult<CompanyLocationResource.CompanyLocation>> {
    return this.http.get<ResourceQueryResult<CompanyLocationResource.CompanyLocation>>(this.url, this.parseParams(request));
  }

  get(request: CompanyLocationResource.GetRequest): Observable<CompanyLocationResource.CompanyLocation> {
    return this.http.get<CompanyLocationResource.CompanyLocation>(this.url + `${request.id}`);
  }

  create(request: CompanyLocationResource.CreateRequest): Observable<IdentityMessage> {
    return this.http.post<IdentityMessage>(this.url, request);
  }

  update(request: CompanyLocationResource.UpdateRequest): Observable<EmptyMessage> {
    return this.http.put(this.url + `${request.id}`, request);
  }

  setDisabled(request: CompanyLocationResource.DisableRequest): Observable<EmptyMessage> {
    return this.http.patch(this.url + `${request.id}/disabled`, request);
  }

  history(request: CompanyLocationResource.HistoryRequest): Observable<ResourceQueryResult<CompanyLocationResource.HistoryItem>> {
    return this.http.get<ResourceQueryResult<CompanyLocationResource.HistoryItem>>(
      this.url + `${request.id}/history-logs?with_read=${request.with_read}`,
      this.parseParams(request)
    );
  }

  constructor(private http: HttpClient, resourceHelper: ResourceHelper) {
    super(resourceHelper, '/company-locations/');
  }

}

export namespace CompanyLocationResource {

  export interface CompanyLocation {
    id: number;
    external_id: string;
    name: string;
    gate_crossing_required: boolean;
    company: CompanyBaseData
    place: AddressResource.PlaceResource;
    disabled: boolean;
  }

  export interface QueryRequest {
    id?: string;
    external_id?: string;
    name?: string;
    company_ids?: string;
    q?: string;
    disabled?: boolean;
    order?: string;
    page_number?: number;
    number_of_items?: number;
    no_progress_bar?: boolean;
  }

  export interface GetRequest {
    id: number;
  }

  export interface CreateRequest {
    external_id?: string;
    name: string;
    gate_crossing_required: boolean;
    company_id: number;
    place: AddressResource.PlaceCreateResourceRequest;
  }

  export interface UpdateRequest {
    id: number;
    external_id: string;
    name: string;
    gate_crossing_required: boolean;
    company_id: number;
    place: AddressResource.PlaceCreateResourceRequest;
  }

  export interface DisableRequest {
    id: number;
    disabled: boolean;
  }

  export interface CompanyBaseData {
    id: number;
    name: string;
  }

  export interface HistoryRequest {
    id: number;
    with_read: boolean;
    q?: string;
    order?: string;
    page_number?: number;
    number_of_items?: number;
  }

  export interface HistoryItem extends HistoryLog.HistoryItemBaseResource {
  }

}
